import compareVersions from 'compare-versions';
import PromoBasicModal from 'src/components/Promotions/PromoBasicModal.svelte';
import { profile_data, user_data } from 'src/stores/account/user';
import { get } from 'svelte/store';
import { version } from '../../../package.json';
import { APP_VERSION_FOR_PROMO_BASIC } from 'src/constants';
import type { ModalConfig } from 'src/types/Modals';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

export const PromoBasicModalConfig: ModalConfig = {
	id: 'promoBasic',
	component: PromoBasicModal,
	props: {
		priority: 80, // Medium priority
		showModal: true,
	},
	rules: [
		{
			check: () => {
				const profileData = get(profile_data);
				const userData = get(user_data);
				const realAppVersion = version.split('-')[0];
				const promoBasicVersion = APP_VERSION_FOR_PROMO_BASIC;

				return (
					!userData?.premium &&
					(!profileData?.promoBasic
						? compareVersions.compare(promoBasicVersion, realAppVersion, '=')
						: compareVersions.compare(promoBasicVersion, profileData.promoBasic, '>') &&
							compareVersions.compare(promoBasicVersion, realAppVersion, '='))
				);
			},
			expected: true,
		},
		NoPremiumVoucherCheckRule,
	],
};
